import { render, staticRenderFns } from "./AnimatedBanner.vue?vue&type=template&id=53b8192f"
import script from "./AnimatedBanner.vue?vue&type=script&lang=js"
export * from "./AnimatedBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports